<template>
  <div class="hobbies" id="hobbies">
    <!-- <b-container > -->
    <b-row>
      <b-col cols="12" md="6" order-md="1" order="2" class="hobbies_grid">
        <b-row class="row1">
          <b-col cols="3">
            <b-row class="r_50 cup">
              <div class="icon">
                <b-icon icon="cup-straw"></b-icon>
              </div>
            </b-row>
            <b-row class="r_50 film">
              <div class="icon">
                <b-icon icon="film"></b-icon>
              </div>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row class="r_100 language" v-b-modal.languages>
              <div class="icon">
                <b-icon icon="chat-text"></b-icon>
              </div>
              <div>
                <h3>Languages</h3>
              </div>
            </b-row>
          </b-col>
          <b-col cols="3">
            <b-row class="r_50 bike">
              <div class="icon">
                <b-icon icon="bicycle"></b-icon>
              </div>
            </b-row>
            <b-row class="r_50 sun">
              <div class="icon">
                <b-icon icon="brightness-alt-high"></b-icon>
              </div>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="row2 whether">
          <app-weather />
        </b-row>
        <b-row class="row3">
          <b-col cols="6">
            <b-row style="height: 40%">
              <b-col cols="6" class="book">
                <b-row class="r_40">
                  <div class="icon">
                    <b-icon icon="book"></b-icon>
                  </div>
                </b-row>
              </b-col>
              <b-col cols="6" class="music">
                <b-row class="r_40">
                  <div class="icon">
                    <b-icon icon="music-note-beamed"></b-icon>
                  </div>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="r_60 camera" v-b-modal.photograph>
              <div class="icon">
                <b-icon icon="camera"></b-icon>
                <h3>Photography</h3>
              </div>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row class="r_60 travelling" v-b-modal.map>
              <div class="icon">
                <b-icon icon="geo-alt"></b-icon>
                <h3>Travelling</h3>
              </div>
            </b-row>
            <b-row style="height: 40%">
              <b-col cols="6" class="cooking">
                <b-row class="r_40">
                  <div class="icon">
                    <b-icon icon="egg-fried"></b-icon>
                  </div>
                </b-row>
              </b-col>
              <b-col cols="6" class="flower">
                <b-row class="r_40">
                  <div class="icon">
                    <b-icon icon="flower1"></b-icon>
                  </div>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="6" order-md="2" order="1">
        <b-row>
          <div class="phone_wrap">
            <div class="phone_top_wrap">
              <div class="phone_top">
                <div class="phone_top_side">
                  <div><b-icon icon="bar-chart-fill"></b-icon></div>
                  <div><b-icon icon="wifi"></b-icon></div>
                  <div><b-icon icon="chat-square-text"></b-icon></div>
                </div>
                <div class="phone_top_side">
                  <div><b-icon icon="phone-vibrate"></b-icon></div>
                  <div><b-icon icon="battery-full"></b-icon></div>
                </div>
              </div>
            </div>
            <div class="hobbies_intro">
              <h1>Hobbies</h1>
              <p>
                One of my hobbies is learning foreign languages, which has shaped the way I think. My mother tongue is
                Vietnamese, and I speak English fluently. I also speak French and Japanese. I love travelling, and on my
                trips I take photos—mostly landscapes.
              </p>

              <p>
                Click on <strong>Languages</strong>,
                <strong>Travelling</strong> and <strong>Photography</strong> to
                discover more!
              </p>
            </div>
            <div class="phone_bottom_wrap">
              <div class="phone_bottom">
                <div><b-icon icon="search"></b-icon></div>
                <div><b-icon icon="code-slash"></b-icon></div>
                <div><b-icon icon="camera"></b-icon></div>
              </div>
            </div>
          </div>
        </b-row>
      </b-col>
    </b-row>
    <!-- </b-container> -->
    <app-travel-map />
    <app-photograph />
    <app-languages />
  </div>
</template>

<script>
import Weather from "../components/Weather.vue";
import TravelMap from "../components/TravelMap.vue";
import Photograph from "../components/Photograph.vue";
import Languages from "../components/Languages.vue";

export default {
  components: {
    appWeather: Weather,
    appTravelMap: TravelMap,
    appPhotograph: Photograph,
    appLanguages: Languages,
  },
};
</script>
